import { render, staticRenderFns } from "./BorrowReturnStatusCardCell.vue?vue&type=template&id=1c5443e8&scoped=true&"
import script from "./BorrowReturnStatusCardCell.vue?vue&type=script&lang=js&"
export * from "./BorrowReturnStatusCardCell.vue?vue&type=script&lang=js&"
import style0 from "./BorrowReturnStatusCardCell.vue?vue&type=style&index=0&id=1c5443e8&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1c5443e8",
  null
  
)

export default component.exports